var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"customer-contact-create","title":"Ansprechpartner erstellen","width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('customer-contact-form',{attrs:{"customerContact":_vm.customerContact,"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }